//import locales
import { useTranslation } from "react-i18next";
import "../../../i18n";

export default function Form () {

    //get locale
    const { t } = useTranslation();

    return (
        <div className='grid grid-cols-12 gap-5'>
            <div className='col-span-6'>
                <label>{t('name')}</label>
                <input type="text" placeholder={t('enter_name')} className='block w-full h-[52px] rounded-xl border border-gray-300 px-4 text-sm focus:border-blue-500 focus:ring-blue-500 outline-none' />
            </div>
            <div className='col-span-6'>
                <label>{t('phone')}</label>
                <input type="text" placeholder={t('enter_phone')} className='block w-full h-[52px] rounded-xl border border-gray-300 px-4 text-sm focus:border-blue-500 focus:ring-blue-500 outline-none' />
            </div>
            <div className='col-span-6'>
                <label>{t('email')}</label>
                <input type="text" placeholder={t('enter_email')} className='block w-full h-[52px] rounded-xl border border-gray-300 px-4 text-sm focus:border-blue-500 focus:ring-blue-500 outline-none' />
            </div>
            <div className='col-span-6'>
                <label>{t('subject')}</label>
                <input type="text" placeholder={t('enter_subject')} className='block w-full h-[52px] rounded-xl border border-gray-300 px-4 text-sm focus:border-blue-500 focus:ring-blue-500 outline-none' />
            </div>
            <div className='col-span-12'>
                <label>{t('message')}</label>
                <textarea rows="17" placeholder={t('enter_message')} className='resize-none block w-full rounded-xl border border-gray-300 p-4 text-sm focus:border-blue-500 focus:ring-blue-500 outline-none'></textarea>
            </div>
            <div className='col-span-12 mt-4'>
                <button className='w-fit px-6 py-3 bg-slate-700 text-white rounded-xl'>{t('send')}</button>
            </div>
        </div>
    );
}